/*
Copyright 2021-2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { useTranslation } from "react-i18next";
import { type FC } from "react";
import { Heading, Text } from "@vector-im/compound-web";

import { FullScreenView } from "../FullScreenView";
import { usePageTitle } from "../usePageTitle";

// Gua's guest server lets guests join the calls they are let into, never start one.
export const HomePage: FC = () => {
  const { t } = useTranslation();
  usePageTitle(t("common.home"));

  return (
    <FullScreenView>
      <Heading size="lg" weight="semibold">
        {t("gua.join_only_title")}
      </Heading>
      <Text>{t("gua.join_only_body")}</Text>
    </FullScreenView>
  );
};
